/**
 * Ce qu'on garde d'un code tapé ou collé : les lettres et les chiffres, dans
 * leur casse, `length` au plus.
 *
 * Un code reçu par message arrive souvent avec ce qui l'entoure — une espace au
 * milieu pour le lire, un tiret, un point final. Les retirer ici, avant de
 * borner la longueur, est ce qui fait qu'un code collé tel quel entre en
 * entier : borner d'abord (un `maxLength` sur le champ) en coupait la fin.
 *
 * La casse n'est jamais touchée : les codes du live font de `a` et de `A` deux
 * caractères différents.
 */
export function cleanCode(raw: string, length: number): string {
  return raw.replace(/[^A-Za-z0-9]/g, "").slice(0, length);
}
